module.exports = __webpack_public_path__ + "static/media/Assist.d32d14c6.svg";